import { FeatureBadge, Flex, Header } from '@driftt/dds'
import { access } from '@driftt/traffic-control'
import React from 'react'

import LeadQualification from 'components/AIConfiguration/LeadQualification'
import { PageLayout } from 'components/PageLayout'
import usePageTitle from 'hooks/usePageTitle'

const AIConfiguration = () => {
  const isAdmin = access.isAdmin()

  usePageTitle('Drift | AI Configuration')

  return isAdmin ? (
    <PageLayout
      sideNav={null}
      header={
        <Flex fullHeight alignItems="center">
          <Header>Qualification rules</Header>
          <FeatureBadge variant="beta" />
        </Flex>
      }
      overflow
    >
      <LeadQualification />
    </PageLayout>
  ) : null
}

export default AIConfiguration
